import React from 'react'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import TxtIntro1 from '../../sharedcomponents/TextIntro/TxtIntro1'
import Cards from '../../components/products/Cards'
import ParallaxOtherPages from '../../sharedcomponents/parallaxOtherPages/parallaxOtherPages.js';
import {imgSlide2} from '../../sharedcomponents/ImageScope';
import Footer from '../../sharedcomponents/footer/Index.js';

import './index.css'
export default function Products(){
  return(
    <>
      <div style={{maxWidth:'1920px'}}>
        <Header productsActive={"active"}/>
        <SubNav2/>
        <ParallaxOtherPages
          parallaxOtherPages_bg={imgSlide2}
          // parallaxOtherPages_title="Nossos produtos."
          // parallaxOtherPages_desc="Bones, Brindes e muito mais..."
          // parallaxOtherPages_txt="Temos os melhores produtos que uma gráfica pode lhe oferecer."
        />
        <br/>
        <br/>
        <br/>
        <TxtIntro1
           TxtIntro_title={"Conheça mais sobre os produtos da HS Design."}
           TxtIntro_description={"Temos chapeus, camisas, casacos, com várias medidas, e tamanhos, e para várias faxa-ectariase os melhores preços."}
        />
        <Cards/> 
        <Footer/>
      </div>
    </>
  );
}